import { createContext } from 'react';

const DailyActiveUsersContext = createContext();


export default DailyActiveUsersContext;